import { render, staticRenderFns } from "./Module.vue?vue&type=template&id=2ba45c87&scoped=true&"
import script from "./Module.vue?vue&type=script&lang=ts&"
export * from "./Module.vue?vue&type=script&lang=ts&"
import style0 from "./Module.vue?vue&type=style&index=0&id=2ba45c87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba45c87",
  null
  
)

component.options.__file = "Module.vue"
export default component.exports